export const sortLang = (data: { language: any }[]) => {
  return data?.sort((a: { language: string }, b: { language: any }) =>
    a.language.localeCompare(b.language)
  );
};
